import { compact } from 'lodash';
// @ts-ignore
const crmBaseUrl = process.env.REACT_APP_CRM_BASE_URL || window._env_.REACT_APP_CRM_BASE_URL;
// @ts-ignore
const crmAppId = process.env.REACT_APP_CRM_APP_ID || window._env_.REACT_APP_CRM_APP_ID;
export const crmQuotePath = (quoteId: string) =>
  !!crmBaseUrl && !!crmAppId
    ? `${crmBaseUrl}main.aspx?appid=${crmAppId}&pagetype=entityrecord&etn=quote&id=${quoteId}`
    : null;

// @ts-ignore
export const appId = process.env.REACT_APP_ID || window._env_.REACT_APP_ID || '';
// @ts-ignore
export const tenantId = process.env.REACT_APP_TENANT_ID || window._env_.REACT_APP_TENANT_ID || '';
// @ts-ignore
export const redirectURL = process.env.REACT_APP_REDIRECT_URL || window._env_.REACT_APP_REDIRECT_URL || '';
export const loginURL = `https://login.microsoftonline.com/${tenantId}`;
export const msGraphApiRoot = 'https://graph.microsoft.com';

// @ts-ignore
export const disableFactoryOrder = window._env_.REACT_APP_DISABLE_FACTORY_ORDER || process.env.REACT_APP_DISABLE_FACTORY_ORDER;

// @ts-ignore
export const customerId = process.env.REACT_APP_DEFAULT_CUSTOMER_ID || window._env_.REACT_APP_DEFAULT_CUSTOMER_ID || '';

// @ts-ignore
export const apimEndpoint = process.env.REACT_APP_APIM_URL || window._env_.REACT_APP_APIM_URL || null;

// @ts-ignore
export const saleAllCarsMbImageToken = process.env.REACT_APP_SALE_ALL_CARS_MB_IMAGE_TOKEN || window._env_.REACT_APP_SALE_ALL_CARS_MB_IMAGE_TOKEN || null;